<template>
  <div :class="['export-input', 'search-input-item', {active: isActive, error: hasError}, styleName]" @click.stop.prevent @keyup.tab="$parent.tabEvent($event, 'ex')" @keyup.enter="$parent.enterEvent($event, 'ex')" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
    <div class="wrap" @click.prevent="inputClick">
    
      <div class="value">
        <transition mode="out-in" @before-enter="beforeEnter" @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave" @leave="leave">
          <!-- <div class="placeholder" key="placeholder" v-if="!isShowInput">{{(defaultPlaceholder && defaultPlaceholder.name) || '输入/选择起运地'}}</div> -->
          <Input   type="text" class="input" ref="input" key="input" @@on-blur="blur" contenteditable="false"  v-model.trim="text" @on-change="inputEvent" 
          :readonly="!isRead?false:'readonly'" />
        </transition>
      </div>

      <!-- <transition @enter="clearEnter" @leave="clearLeave">
        <img src="@/assets/images/icons/search/clear.png" class="clear" @click.prevent="clearContentHandle" v-show="isShowClear" v-if="text">
        <svg-icon icon-class="arrow" class="arraw" v-else></svg-icon>
      </transition> -->

      <!-- <transition @before-enter="divideBeforeEenter" @enter="divideEnter" @leave="divideLeave">
        <div class="divide" v-show="isShowDropDown"></div>
      </transition> -->
    </div>

    <transition @enter="dropdownEnter" @after-enter="afterDropdownEnter" @before-leave="beforeDropdownLeave" @leave="dropdownLeave" @after-leave="afterDropdownLeave">
      <Dropdown v-show="isShowDropDown" :currentTab="currentTab" :value="text" @selectItem="selectItem" :dropDownHeight="dropDownHeight" ref="dropdownComponent" :width="width"></Dropdown>
    </transition>

    <Loader :loadType="1" :isShowMask="false" v-show="!exporterReady && isShowDropDown" class="black" style="top:100%;margin-top:30px;left:50%;margin-left:-25px;"></Loader>
  </div>
</template>

<script>
import Vue from 'vue'
import Velocity from 'velocity-animate'
// eslint-disable-next-line
import VelocityUI from 'velocity-animate/velocity.ui'
import Dropdown from './ExportDropdown2'
import Loader from '@/components/layout/Loader'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapDataState } = createNamespacedHelpers('data')
const { mapState: mapSearchState } = createNamespacedHelpers('search')
const { mapGetters: mapExporterGetters, mapMutations: mapExporterMutations } = createNamespacedHelpers('search/exporter')

export default {
  name: 'Export',
  props: {
    
    width: {
      type: String,
      require: false
    },
    styleName: {
      type: String,
      default: 'n',
      required: false
    }
  },
  data () {
    return {
      currentState: 'rate',
      isActive: false,
      hasError: false,
      isShowInput: false,
      isShowClear: false,
      isShowDropDown: false,
      allowShowDropDown: true,
      currentTab: 't1',
      text: '',
      dropDownHeight: {},
      isRead: false
    }
  },
  components: { Dropdown, Loader },
  computed: {
    value: {
      get () {
        if (this.currentState === 'rate') {
          
          return this.getRateValue()
        } else {
          return this.getRulesValue()
        }
      },
      set (v) {
        if (this.currentState === 'rate') {
          this.setRateValue(v)
        } else {
          this.setRulesValue(v)
        }
      }
    },
    defaultPlaceholder () {
      return {}
    },
    ...mapDataState({
      // defaultPlaceholder: state => state.exporterPlaceholder,
      exporterReady: state => state.exporterReady
    }),
    ...mapSearchState({
      lastHistory: state => state.history.all && state.history.all[0]
    })
  },
  watch: {
    value (newVal, oldVal) {
      if (newVal.id && (newVal.text || '') !== (this.text || '')) {
        this.allowShowDropDown = false
        this.text = newVal.text
        this.isShowInput = !this._.isEmpty(this.text)
       
      }
       this.$emit('input',newVal.id)
    },
   
  },
  mounted () {
    let vm = this
    document.addEventListener('click', this.clickOut)
    this.$nextTick(() => {
      this.$root.$on('appClicker', function (event) {
        vm.isShowDropDown = false
      })
      // if (!this.value.id && !this._.isEmpty(this.lastHistory) && !this._.isEmpty(this.lastHistory.exporter)) {
      //   this.setDefaultValue(this.lastHistory.exporter)
      // }
      let minHeight = 200
      let maxHeight = 200
      if (this.$parent.$options.name === 'QuickSearch') {
        maxHeight = 300
      } else {
        maxHeight = this._h.getWinHeight() - (this._h.getScrollTop() + this._h.getOffset(this.$el).bottom) - 50
        if (maxHeight > 300) maxHeight = 300
      }
      maxHeight = this._.max([minHeight, maxHeight])
      this.dropDownHeight = {
        minHeight: minHeight,
        height: maxHeight,
        maxHeight: maxHeight
      }
    })
  },
  methods: {
    clickOut(e) {
            let drop = this.$refs.dropdownComponent
            if (drop && drop.contains && !drop.contains(e.target) && this.isShowDropDown) {
                this.isShowDropDown = false
            }
    },
    setDefaultValue (v) {
      if (this._.isString(v)) {
        let res = this.$refs.dropdownComponent.getAutoCompleteExporter()(v)
        if (res && res.length > 0) {
          this.allowShowDropDown = false
          this.isShowInput = true
          this.selectItem(this._.trim(res[0].id), this._.trim(res[0].name), true)
        }
      } else {
        this.allowShowDropDown = false
        this.isShowInput = true
        this.value = {id: this._.trim(v.id), text: this._.trim(v.text)}
        this.text = this.value.text
      }
      setTimeout(() => {
        this.$refs.dropdownComponent && this.$refs.dropdownComponent.setDefault(false)
      }, 100)
    },
    setValueFromDefaultPlaceholder () {
      if ((!this.text || !this.value.id) && !this._.isEmpty(this.defaultPlaceholder)) {
        this.value = {id: this._.trim(this.defaultPlaceholder.id), text: this._.trim(this.defaultPlaceholder.name)}
        this.text = this.value.text
      }
    },
    inputClick (event) {
      this.isShowDropDown = true
      if (!this.isRead) {
        if ((!this.value || !this.value.id) && !this.isShowInput) {
          this.text = ''
        }
        // this.$emit('handleClick', event, 'exporter')
        this.$refs.dropdownComponent && this.$refs.dropdownComponent.setDefault(!!this.text && !this.value.id)
        if (this.isShowInput) {
          this.isShowDropDown = true
        }
        this.allowShowDropDown = true
        this.isShowInput = true
        this.isActive = true
        this.isShowClear = false
      }
    },
    clearContent (isShowInputText = true) {
      this.isShowClear = false
      this.isShowInput = isShowInputText
      this.isActive = isShowInputText
      this.value = ''
      this.text = ''
    },
    clearContentHandle () {
      this.clearContent()
      this.$refs.input && this.$refs.input.focus()
    },
    resetContent (isShowDP = false) {
      if (!this.isRead) {
        if (isShowDP) {
          this.isShowInput = false
          setTimeout(() => {
            this.allowShowDropDown = true
            this.clearContent()
          }, 100)
        } else {
          this.clearContent(false)
        }
      }
    },
    blur () {
      this.isShowDropDown = false
      if (!this.checkInputContent()) {
        this.clearContent()
      }
    },
    closeDowndown (isBlur, event) {
      if (isBlur && this.$refs.input) this.$refs.input.blur()
      this.isShowDropDown = false
      if (isBlur === undefined) {
        this.$emit('closeDropdown', event, 'ex')
      }
    },
    selectItem (id, text, isDefault = false, event = window.event) {
      this.value = { id: this._.trim(id), text: this._.trim(text) }
      this.text = this.value.text
      this.isShowDropDown = false
      this.isActive = false
      if (!isDefault && this.value.id) {
        setTimeout(() => {
          this.$emit('closeDropdown', event, 'ex')
        }, 200)
      }
    },
    checkInputContent (type = 1) {
      if (type === 1) {
        return this._.trim(this.text) !== ''
      } else if (type === 2) {
        return this._.trim(this.text) !== '' && this.value.id
      } else if (type === 3) {
        return this._.trim(this.text) !== '' && !this.value.id
      }
    },
    mouseEnter () {
      if (!this.isShowDropDown && this.checkInputContent()) {
        this.isShowClear = true
      }
    },
    mouseLeave () {
      this.isShowClear = false
    },
    clearEnter (el, done) {
      this.text && Velocity(el, { rotateZ: 90 }, { duration: 100, complete: done })
    },
    clearLeave (el, done) {
      this.text && Velocity(el, { rotateZ: 0 }, { duration: 100, complete: done })
    },
    inputEvent (event) {
      this.value = ''
    },
    beforeEnter (el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(20px)'
    },
    enter (el, done) {
      Velocity(el, { opacity: 1, translateY: '0px' }, { duration: 100, complete: done })
    },
    afterEnter (el) {
      if (this.isShowInput) {
        this.$nextTick(() => {
          if (this.allowShowDropDown) {
            this.$refs.input.focus()
            if (!this.isShowDropDown) {
              this.isShowDropDown = true
            }
          } else {
            this.allowShowDropDown = true
          }
        })
      }
    },
    beforeLeave (el) {
      el.style.transform = 'translateY(0px)'
    },
    leave (el, done) {
      Velocity(el, { opacity: 0, translateY: '-20px' }, { duration: 100, complete: done })
    },
    divideBeforeEenter (el) {
      el.style.opacity = 0.1
    },
    divideEnter (el, done) {
      Velocity(el, { width: '100%', opacity: 1 }, { duration: 200, complete: done })
    },
    divideLeave (el, done) {
      Velocity(el, { width: '0%', opacity: 0.1 }, { duration: 200, complete: done })
    },
    dropdownEnter (el, done) {
      this.$refs.dropdownComponent.updateContentHeight()
      Velocity(el, 'transition.slideDownIn', { duration: 150, complete: done })
    },
    afterDropdownEnter (el) {
      this.$refs.dropdownComponent.refresh()
      // this.$parent.handleClick(null, 'exporter')
    },
    beforeDropdownLeave (el) {
      if (this.checkInputContent(3)) {
        let res = this.$refs.dropdownComponent.getAutoCompleteExporter()(this.text)
        if (res.length > 0) {
          this.selectItem(res[0].id, res[0].name)
        } else {
          // this.hasError = true
          this.$Message.warning({content: this.$t('query.message.export_error'), closable: true})
        }
      }
      if (this.checkInputContent()) {
        if (this.$refs.input) this.$refs.input.blur()
      } else {
        this.isShowInput = false
      }
      this.isActive = false
    },
    dropdownLeave (el, done) {
      Velocity(el, 'transition.slideUpOut', { duration: 150, complete: done })
    },
    afterDropdownLeave (el) {
      if (this.$refs.dropdownComponent) {
        this.$refs.dropdownComponent.setDefault(!!this.text && !this.value.id)
      }
    },
    ...mapExporterGetters([
      'getRateValue',
      'getRulesValue'
    ]),
    ...mapExporterMutations([
      'setRateValue',
      'setRulesValue'
    ])
  }
}
</script>
<style scoped>
.search-input-item{

  /*font-size: 11px;*/
  /*float: left;*/
  position: relative;
  
}
.non-empty>>>  input {
  background: #faffbd !important;
}

.search-input-item .wrap{
  padding: 3px 25px 3px 6px;
}

.wrap >>>input{
  padding: 3px 25px 3px 6px;
  color: #333;
          border: 1px solid #0774b5;border-radius: inherit;
          font-size: 15px;       
}
.wrap >>>.ivu-input:focus {
  outline: 0;
  box-shadow:none
}


.search-input-item .title{
  color: #0774b5;
  font-weight: bold;
  /*font-size: 10px;*/
  font-size: 12px;
  background: url("~@/assets/images/home/rate.png") 0 4px no-repeat transparent;
  padding-left: 18px;
  background-size: 12px;
  margin-bottom: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.search-input-item.active .title{
  /* background-image: url("~@/assets/images/icons/search/export_active.png"); */
  /* color: #0774b5; */
}

.search-input-item .value{
  color: #333;
  /* padding-left: 11px; */
  /*font-size: 1.1rem;*/


}

.search-input-item .value .placeholder{
  color: #8b8989;
  font-size: 12px;
  outline: 0 none;
  cursor: text;
  height: 30px;
  line-height: 30px;
  padding: 0 5px;
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.search-input-item.s .title{
  position: absolute;
  width: 11px;
  height: 13px;
  background-position-y: 2px;
  top: 50%;
  left: 8px;
  transform: translateY(-50%);
  font-size: 0;
}
.search-input-item.s .title span{
  display: none;
}
.search-input-item.s .value{
  padding-left: 15px;
  height: 22px;
  line-height: 22px;
}
.clear,
.arraw{
  position: absolute;
  top:50%;
  width: 10px !important;
  height: 10px !important;
  margin-top: -5px;
  right: 9px;
  cursor: pointer;
}
.arraw{
  color: #b5b2b2;
  transition: all 0.3s;
}
.active .arraw {
  color: #2681FF;
  transform: rotate(180deg);
}
.search-input-item:hover .arraw{
  color: #2681FF;
}
.divide{
  background-color: #2681FF;
  position: absolute;
  left:0;
  top:100%;
  height: 0.5px;
  width: 0%;
  z-index: 1001;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Export2.vue